var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import { AngledContainer } from '../angledContainer/AngledContainer';
import { Button } from '../../components/CtaButtons';
import gsap from 'gsap';
import striptags from 'striptags';
export var HeroText = function (_a) {
    var _b = _a.data, primaryBg = _b.primaryBg, secondaryBg = _b.secondaryBg, copy = _b.copy, orientation = _b.orientation, cta = _b.cta, internalRef = _a.internalRef;
    var angles = useMemo(function () {
        var angleObject = {
            topLeftInit: 0,
            topLeftEnd: 0,
            topRightInit: 100,
            topRightEnd: 0,
            bottomRightInit: 100,
            bottomRightEnd: 80,
            bottomLeftInit: 0,
            bottomLeftEnd: 100,
        };
        if (orientation === 'left') {
            angleObject.bottomRightEnd = 100;
            angleObject.bottomLeftEnd = 80;
        }
        return angleObject;
    }, [orientation]);
    useEffect(function () {
        var tl = gsap.timeline();
        tl.to('.hero-text-anime', {
            autoAlpha: 1,
            duration: 1,
            stagger: {
                each: 0.5,
            },
            delay: 0.5,
        });
    }, []);
    var isValidString = function (stringValue) {
        return typeof stringValue === 'string' && stringValue.length > 0;
    };
    var isCtaActive = useMemo(function () {
        return (typeof cta === 'object' &&
            isValidString(cta.label) &&
            isValidString(cta.url));
    }, [cta]);
    var isCopyActive = useMemo(function () {
        return isValidString(copy);
    }, [cta]);
    var plainTextContent = striptags(copy);
    return (_jsxs("div", __assign({ ref: internalRef, className: "text-white relative h-[470px] w-full snap-center md:h-[757px] lg:h-[829px]" }, { children: [_jsx(AngledContainer, __assign({ className: "absolute top-[35px] -left-[25px] h-full w-full md:top-[60px] md:-left-[85px]", background: secondaryBg }, angles), void 0),
            _jsx(AngledContainer, __assign({ className: "absolute top-0 left-0 h-full w-full flex justify-center items-center", background: primaryBg }, angles, { children: _jsxs("div", __assign({ className: "hero-text-anime", style: { visibility: 'hidden' } }, { children: [copy && (_jsx("h1", __assign({ className: "w-[271px] font-light text-center text-[32px] leading-[1.25] md:w-[483px] md:text-[40px] lg:w-[793px] lg:text-[56px] lg:leading-[1.14]" }, { children: plainTextContent }), void 0)),
                        isCtaActive && (_jsx("div", __assign({ className: "hero-text-anime", style: { visibility: 'hidden' } }, { children: _jsx(Button, __assign({ classes: [
                                    'text-enblue-500',
                                    'focus:bg-enblue-light',
                                    'ArticleButtons_custom',
                                    'one-color-hero--cta',
                                    'mx-auto',
                                ], animate: "animate-white" }, { children: _jsx("a", __assign({ className: "text-enblue-500 h-full w-full", href: cta === null || cta === void 0 ? void 0 : cta.url }, { children: cta === null || cta === void 0 ? void 0 : cta.label }), void 0) }), void 0) }), void 0))] }), void 0) }), void 0)] }), void 0));
};
